import { hasMany, belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const TYPES = {
  ADVANCE_ADJUSTMENT: 'advance_adjustment',
  BASE: 'base',
  CANCELLATION: 'cancellation',
  EXPENSE: 'expense',
};

export const PROJECT_LINE_ITEM = {
  TYPES,
};

const ProjectLineItem = ShModel.extend({
  amount: attr('number'),
  isEditable: attr('boolean'),
  invoiceDueAmount: attr('number'),
  paymentDueAmount: attr('number'),
  invoiceFinalAmount: attr('number'),
  paymentFinalAmount: attr('number'),
  description: attr('string'),
  type: attr('string'),

  //timestamps
  createdAt: attr('date'),
  updatedAt: attr('date'),

  //Relationships
  application: belongsTo('application', { async: false }),
  relatedShInvoiceLineItems: hasMany('shInvoiceLineItem', { async: false, inverse: 'derivedFromProjectLineItem' }),
  relatedShPaymentLineItems: hasMany('shPaymentLineItem', { async: false, inverse: 'derivedFromProjectLineItem' }),
});

export default ProjectLineItem;
